import { render, staticRenderFns } from "./transfer-numbers.vue?vue&type=template&id=a66520ca"
import script from "./transfer-numbers.vue?vue&type=script&lang=js"
export * from "./transfer-numbers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports